import React, { useState, useEffect } from "react";
import { Box, Button, Flex, Icon, MenuItem, MenuList, Menu, MenuButton } from "@chakra-ui/react";
import { FaChevronDown, FaChevronUp, FaEnvelope,FaPhoneAlt, FaPlusCircle } from "react-icons/all";
import "./CurrentStatus.scss";
import { Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverCloseButton, PopoverHeader, PopoverBody } from "@chakra-ui/react";
import { MessageBoard } from "../../MessageBoard/Messageboard";
import moment from "moment";
import { CallbackRequestModal } from "./CallbackRequestModal";
import { Comment, CurrentStatusProps } from "../../modals/Interface";
import { Avatar, AvatarBadge } from "@chakra-ui/react";
import { IDS } from "../../constants/Ids";
import APIService from "../../Services/APIService";
import { BookingSlot } from "../../modals/TaskPayload";
import { apiIbsAdBaseUrl } from "../../Services/IBSAdonisService";

export const CurrentStatus: React.FC<CurrentStatusProps> = ({
  status,
  comments,
  onRequestCallback,
  onSendMessage,
  onClose,
  ibsService,
  ibsAdonisService,
  estimateDetails,
  notes,
  notesSuggestions,
  showHideLoader = () => {},
  notesAdded = () => {},
  newMessage = () => {},
  currentUser,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isCallbackModalOpen, setIsCallbackModalOpen] = useState(false);
  const [latestCallbackTask, setLatestCallbackTask] = useState<any>(null);
  const [allCallBackTasks, setAllCallBackTasks] = useState<any>([]);

  const fetchLatestCallbackTask = async () => {
    if (!ibsAdonisService || !estimateDetails?.estimateId) {
      return;
    }
    
    try {
      const callbackResponse = await ibsAdonisService.getTasksForUser("58b2b027-55b5-49cc-849c-f4c0a82c0883");
      
      if (callbackResponse?.IsSuccess && callbackResponse?.Data) {
        setAllCallBackTasks(callbackResponse?.Data)
        const estimateTasks = callbackResponse.Data.filter((task: any) => {
          const hasEstimateAssignment = task.assignments?.some((assignment: any) => 
            assignment.assignedToName == estimateDetails.estimateNumber
          );            
          return hasEstimateAssignment;
        });

        const callbackTasks = estimateTasks.filter((task: any) => {
          const hasCallbackAssignment = task.assignments?.some((assignment: any) => 
            assignment.assignedToName === "Call Backs/Reworks"
          );
          return hasCallbackAssignment;
        });
        
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        
        const validDueDateTasks = callbackTasks.filter((task: any) => {
          if (!task.dueDate) return false;
          const dueDate = new Date(task.dueDate);
          return dueDate >= today;
        });
        
        if (validDueDateTasks.length > 0) {
          const latestTask = validDueDateTasks.reduce((latest: any, current: any) => {
            const latestDate = new Date(latest.created);
            const currentDate = new Date(current.created);
            return currentDate > latestDate ? current : latest;
          });
          
          setLatestCallbackTask(latestTask);
        } else {
          setLatestCallbackTask(null);
        }
      } else {
        setLatestCallbackTask(null);
        setAllCallBackTasks([])
      }

    } catch (error) {
      console.error('Error fetching tasks:', error);
      setLatestCallbackTask(null);
      setAllCallBackTasks([])
    }
  };
  const addNewCallbackTask = (newTask: any) => {
    fetchLatestCallbackTask();
  };
  const refreshTasks = () => {
    fetchLatestCallbackTask();
  };
  
   useEffect(() => {
     fetchLatestCallbackTask();
   }, [ibsAdonisService, estimateDetails?.estimateId]);

   React.useEffect(() => {
     const handleMenuOpen = () => {
       document.body.classList.add('menu-open');
     };

     const handleMenuClose = () => {
       document.body.classList.remove('menu-open');
     };

     // Listen for menu open/close events
     const menuButtons = document.querySelectorAll('.avatar_btn');
     menuButtons.forEach(button => {
       button.addEventListener('click', handleMenuOpen);
     });

     // Listen for clicks outside menu to close
     document.addEventListener('click', (e) => {
       const target = e.target as Element;
       if (target && !target.closest('.chakra-menu')) {
         handleMenuClose();
       }
     });

     return () => {
       menuButtons.forEach(button => {
         button.removeEventListener('click', handleMenuOpen);
       });
       document.removeEventListener('click', handleMenuClose);
       document.body.classList.remove('menu-open');
     };
   }, [comments]);

  React.useEffect(() => {
    const handleMenuOpen = () => {
      document.body.classList.add('menu-open');
    };

    const handleMenuClose = () => {
      document.body.classList.remove('menu-open');
    };

    // Listen for menu open/close events
    const menuButtons = document.querySelectorAll('.avatar_btn');
    menuButtons.forEach(button => {
      button.addEventListener('click', handleMenuOpen);
    });

    // Listen for clicks outside menu to close
    document.addEventListener('click', (e) => {
      const target = e.target as Element;
      if (target && !target.closest('.chakra-menu')) {
        handleMenuClose();
      }
    });

    return () => {
      menuButtons.forEach(button => {
        button.removeEventListener('click', handleMenuOpen);
      });
      document.removeEventListener('click', handleMenuClose);
      document.body.classList.remove('menu-open');
    };
  }, [comments]);


  const [availabilityData, setAvailabilityData] = React.useState<[] | BookingSlot[]>([])

  useEffect(() => {
    const fetchBookingSlots = async () => {
      const apiService = new APIService();
      const response = await apiService.getAvailabilityData();
      setAvailabilityData(response.data);
    };
    fetchBookingSlots();
  }, []);


  return (
    <Box className="current-status__container">

      <div className="current-status__content" style={{ display: 'flex' }}>
        
        <Box className="current-status__comments">
          <div
            className={`current-status__comments-box${expanded ? " expanded" : ""}`}
          >
            <div className={`current-status__comments-header${expanded ? " expanded" : ""}`}>
            <div className="current-status__comments-label">Repairer comments</div>
          {expanded && (
            <button
              className="current-status__close-btn"
              onClick={() => setExpanded(false)}
              aria-label="Close"
            >
              &times;
            </button>
          )}
              {
                !expanded && (
                  <button
                    onClick={() => setExpanded(true)}
                    aria-label="See more"
                    className="viewMoreBtn"
                  >
                    View All
                  </button>
                )
              }
            </div>
          
            <div className={`current-status__comments-content${expanded ? " expanded" : ""}`}>
            {comments.filter((comment: Comment) => comment.body.includes("Repairer message to customer")).map((comment: Comment) => (
              <div key={comment.noteId} className="current-status__comment">
                <div className="current-status__comment-avatar-container">
                  <Menu>
                    <MenuButton className="avatar_btn">
                      <Avatar
                        name={comment.userName}
                        src={`
                          ${apiIbsAdBaseUrl}GetUserThumbnail/${comment?.userId}`
                        }
                      >
                        <AvatarBadge bg="blue.700" boxSize="1.15em">
                          {" "}
                          <FaPlusCircle />
                        </AvatarBadge>
                      </Avatar>
                    </MenuButton>
                    {comment.phoneNumber || comment.email ? (
                      <>
                        {" "}
                        <MenuList>
                          {comment.phoneNumber ? (
                            <>
                              <MenuItem
                                onClick={() =>
                                  window.open(
                                    "tel:" + comment.phoneNumber,
                                    "_self"
                                  )
                                }
                              >
                                <Box mr={2}>
                                  <FaPhoneAlt />{" "}
                                </Box>{" "}
                                Call
                              </MenuItem>
                            </>
                          ) : null}
                                                     {comment.email ? (
                             <>
                               <MenuItem
                                 onClick={() =>
                                   window.open("mailTo:" + comment.email)
                                 }
                               >
                                 <Box mr={2}>
                                   <FaEnvelope />{" "}
                                 </Box>{" "}
                                 E-mail
                               </MenuItem>
                             </>
                           ) : null}
                        </MenuList>
                      </>
                    ) : null}
                  </Menu>
                </div>

                <div className="current-status__comment-content">
                  <h3 className="current-status__comment-title">{comment?.userName || "Unknown"}</h3>
                  <p className="current-status__comment-description">{comment.body.split("Repairer message to customer:")[1]}</p>
                
                  <p className="current-status__comment-date">{moment(comment.created).format("DD/MM/YYYY HH:MM A")}</p>
                  </div>
              </div>
            ))}
            </div>
          </div>
        </Box>
        

        
             
                 <Box className="current-status__actions">
              
           <Button
             
             className="current-status__button"
             onClick={() => {
               setIsCallbackModalOpen(true);
             }}
             w="100%"
            //  disabled={!!latestCallbackTask}
           >
                           {latestCallbackTask ? (
                <>
              
      <span style={{fontSize: "12px",fontWeight: "bold"}}>Callback Scheduled <br/><span style={{fontSize: "10px",fontWeight: "normal"}}> {moment(latestCallbackTask.dueDate).format("ddd, D MMMM YYYY")} <br/> {moment(latestCallbackTask.dueDate).format("h:mm A")}</span></span> &emsp;
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.47495 0.81751C5.2193 0.199959 4.54531 -0.128738 3.9012 0.047231L0.979449 0.844071C0.40174 1.00344 0 1.52803 0 2.12566C0 10.3397 6.66025 17 14.8743 17C15.472 17 15.9966 16.5983 16.1559 16.0206L16.9528 13.0988C17.1287 12.4547 16.8 11.7807 16.1825 11.525L12.9951 10.197C12.4539 9.97121 11.8264 10.1273 11.4579 10.5821L10.1165 12.219C7.77915 11.1133 5.88665 9.22085 4.78104 6.88345L6.41788 5.54543C6.87274 5.17357 7.02879 4.54938 6.80302 4.00819L5.47495 0.82083V0.81751Z" fill="#3182CE"/>
                  </svg>
                </>
              ) : (
               <>
                 Request a call back &emsp;
                 <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M5.47495 0.81751C5.2193 0.199959 4.54531 -0.128738 3.9012 0.047231L0.979449 0.844071C0.40174 1.00344 0 1.52803 0 2.12566C0 10.3397 6.66025 17 14.8743 17C15.472 17 15.9966 16.5983 16.1559 16.0206L16.9528 13.0988C17.1287 12.4547 16.8 11.7807 16.1825 11.525L12.9951 10.197C12.4539 9.97121 11.8264 10.1273 11.4579 10.5821L10.1165 12.219C7.77915 11.1133 5.88665 9.22085 4.78104 6.88345L6.41788 5.54543C6.87274 5.17357 7.02879 4.54938 6.80302 4.00819L5.47495 0.82083V0.81751Z" fill="#3182CE"/>
                 </svg>
               </>
             )}
           </Button>
          {/* Chat Popover for 'Send us a message' */}
                     <Popover
             placement="bottom"
             isOpen={isChatOpen}
             onOpen={() => setIsChatOpen(true)}
             onClose={() => setIsChatOpen(false)}
             closeOnBlur={true}
             closeOnEsc={true}
           >
            <PopoverTrigger>
              <Button
                className="current-status__button"
                w="100%"
                mt={1}
                onClick={() => setIsChatOpen(true)}
              >
                Send us a message &emsp;
                <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.17553 10.3125C9.58674 10.3125 12.3507 8.00391 12.3507 5.15625C12.3507 2.30859 9.58674 0 6.17553 0C2.76432 0 0.000324924 2.30859 0.000324924 5.15625C0.000324924 6.28711 0.436746 7.33301 1.17599 8.18555C1.07208 8.46094 0.9177 8.7041 0.754413 8.90918C0.611908 9.09082 0.466434 9.23145 0.359556 9.32812C0.306117 9.375 0.261584 9.41309 0.231895 9.43652C0.217051 9.44824 0.205176 9.45703 0.199238 9.45996L0.1933 9.46582C0.0300134 9.58594 -0.041239 9.79688 0.0240757 9.9873C0.0893904 10.1777 0.27049 10.3125 0.475341 10.3125C1.12255 10.3125 1.7757 10.1484 2.319 9.94629C2.59213 9.84375 2.84745 9.72949 3.06715 9.6123C3.98155 10.0576 5.04143 10.3125 6.17553 10.3125ZM13.3008 5.15625C13.3008 8.44629 10.3586 10.9248 6.87321 11.2207C7.59464 13.4004 9.98754 15 12.8258 15C13.9599 15 15.0197 14.7451 15.9341 14.2998C16.1568 14.417 16.4092 14.5312 16.6823 14.6338C17.2256 14.8359 17.8787 15 18.526 15C18.7308 15 18.9149 14.8682 18.9772 14.6748C19.0396 14.4814 18.9713 14.2705 18.805 14.1504L18.7991 14.1445C18.7931 14.1387 18.7813 14.1328 18.7664 14.1211C18.7367 14.0977 18.6922 14.0625 18.6388 14.0127C18.5319 13.916 18.3864 13.7754 18.2439 13.5938C18.0806 13.3887 17.9262 13.1426 17.8223 12.8701C18.5616 12.0205 18.998 10.9746 18.998 9.84082C18.998 7.12207 16.4774 4.89258 13.28 4.69922C13.2919 4.84863 13.2978 5.00098 13.2978 5.15332L13.3008 5.15625Z" fill="#3182CE"/>
                </svg>
              </Button>
            </PopoverTrigger>
            <PopoverContent minWidth="350px" maxWidth="90vw" marginRight="10px" className="shadow-lg">
              <PopoverArrow />
              <PopoverCloseButton />
              <PopoverHeader>Messages</PopoverHeader>
              <PopoverBody maxHeight="70vh" display="flex" overflow="auto">
                <MessageBoard
                  hideScreen={() => setIsChatOpen(false)}
                  ibsService={ibsService}
                  ibsAdonisService={ibsAdonisService}
                  estimateId={estimateDetails?.estimateId || ""}
                  estimateNumber={estimateDetails?.estimateNumber || ""}
                  notes={notes}
                  notesAdded={notesAdded}
                  showHideLoader={showHideLoader}
                  newMessage={newMessage}
                  notesSuggestions={notesSuggestions}
                  estimateDetails={estimateDetails}
                  showOnlyUserComments={true}
                />
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </Box>
      </div>
      
      {/* Callback Request Modal */}
      {
        isCallbackModalOpen &&
        <CallbackRequestModal
           isOpen={isCallbackModalOpen}
           onClose={() => setIsCallbackModalOpen(false)}
           onRequestCallback={(date, time, newTask) => {
             if (newTask) {
               // Immediately update the latest callback task with the newly created task
               addNewCallbackTask(newTask);
             }
             if (onRequestCallback) {
               onRequestCallback();
             }
           }}
           ibsAdonisService={ibsAdonisService}
           estimateDetails={estimateDetails}
           showHideLoader={showHideLoader}
           availability={availabilityData}
           allCallBackTasks={allCallBackTasks}
           currentUser={currentUser}
         />
      }

    </Box>
  );
}; 